<template>
  <simple-activity>

    <!-- HEADER -->
    <!-- Left side button - primary actions -->
    <template v-slot:primaryButton>
      <footer-button type="New" @new="newClick"></footer-button>
    </template>

    <!-- toolbars -->
    <template v-slot:toolButtons>
      <b-btn aria-label="undo" variant="plm-toolbar-secondary" title="Undo">
        <font-awesome-icon icon="undo" />
      </b-btn>
      <b-btn aria-label="redo" variant="plm-toolbar-secondary" title="Redo">
        <font-awesome-icon icon="redo" />
      </b-btn>
    </template>

    <!-- danger actions on the right -->
    <template v-slot:dangerButton>
      <footer-button type="Delete" label="Danger!" label-break-point="sm"
                     @delete="deleteClick"></footer-button>
    </template>
    <!-- HEADER END-->

    <!-- CONTENT -->
    <b-container class="pt-1 px-2" fluid="true">
      <b-row no-gutters>
        <b-col>
          <b-checkbox v-model="unsavedChanges">Ask before close?</b-checkbox>
        </b-col>
      </b-row>
    </b-container>
    <!-- CONTENT END-->
    <template v-slot:bottomLine>
      Some stuff on the bottom
    </template>

    <template v-slot:footer>
      <!-- extra footer buttons -->
    </template>
  </simple-activity>
</template>

<script>
import Activity from "@/activity/Activity";
import Perms from "@/server/Perms";
import PermissionsSet from "@/server/PermissionsSet";
import FooterButton from "@/components/navbar/FooterButton";
import Log from "@/utils/Log";
import DialogManager from "@/utils/DialogManager";
import SimpleActivity from "@/activity/templates/layouts/SimpleActivity";


export default {
  name: "SimpleActivityTemplate",
  components: {SimpleActivity, FooterButton },
  permission: Perms.SUPERUSER,

  created(){
    if(window['_mem_bombs']) {
      this.bomb = new ArrayBuffer(50 * 1024 * 1024);
      console.log("Bomb!!!!");
    }
  },

  methods: {
    ...Activity.methods,

    getTitle() {
      return "Simple Activity";
    },
    async canClose(){
      return await DialogManager.canClose(this.unsavedChanges);
    },

    async newClick(){
      Log.debug("Wow!");
      await DialogManager.info($tr('newClicked','New clicked'),
          $tr('newButtonClicked','A new button was clicked'));
    },
    async deleteClick(){
      await DialogManager.info($tr('deleteClicked','Delete clicked'),
          $tr('deleteButtonClicked','A Delete button was clicked'));
    },

  },
  data:function(){return {
    unsavedChanges: false,
    permissions: new PermissionsSet(),
  }}
}
</script>
